"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const KEY_BACKSPACE = 8;
const KEY_DELETE = 46;
const KEY_F2 = 113;
const KEY_ENTER = 13;
const KEY_TAB = 9;
const NumericEditorReact = (0, react_1.forwardRef)((props, ref) => {
    const createInitialState = () => {
        let startValue;
        let highlightAllOnFocus = true;
        if (props.keyPress === KEY_BACKSPACE || props.keyPress === KEY_DELETE) {
            // if backspace or delete pressed, we clear the cell
            startValue = '';
        }
        else if (props.charPress) {
            // if a letter was pressed, we start with the letter
            startValue = props.charPress;
            highlightAllOnFocus = false;
        }
        else {
            // otherwise we start with the current value
            startValue = props.value;
            if (props.keyPress === KEY_F2) {
                highlightAllOnFocus = false;
            }
        }
        return {
            value: startValue,
            highlightAllOnFocus
        };
    };
    const initialState = createInitialState();
    const [value, setValue] = (0, react_1.useState)(initialState.value);
    const [highlightAllOnFocus, setHighlightAllOnFocus] = (0, react_1.useState)(initialState.highlightAllOnFocus);
    const refInput = (0, react_1.useRef)(null);
    const isLeftOrRight = event => {
        return [37, 39].indexOf(event.keyCode) > -1;
    };
    const getCharCodeFromEvent = event => {
        event = event || window.event;
        return (typeof event.which === "undefined") ? event.keyCode : event.which;
    };
    const isCharNumeric = charStr => {
        return /\d/.test(charStr);
    };
    const isKeyPressedNumeric = event => {
        const charCode = getCharCodeFromEvent(event);
        const charStr = event.key ? event.key : String.fromCharCode(charCode);
        return isCharNumeric(charStr);
    };
    const deleteOrBackspace = event => {
        return [KEY_DELETE, KEY_BACKSPACE].indexOf(event.keyCode) > -1;
    };
    const finishedEditingPressed = event => {
        const charCode = getCharCodeFromEvent(event);
        return charCode === KEY_ENTER || charCode === KEY_TAB;
    };
    const onKeyDown = event => {
        if (isLeftOrRight(event) || deleteOrBackspace(event)) {
            event.stopPropagation();
            return;
        }
        if (!finishedEditingPressed(event) && !isKeyPressedNumeric(event)) {
            if (event.preventDefault)
                event.preventDefault();
        }
    };
    (0, react_1.useEffect)(() => {
        window.addEventListener('keydown', onKeyDown);
        return () => {
            window.removeEventListener('keydown', onKeyDown);
        };
    }, [onKeyDown]);
    (0, react_1.useImperativeHandle)(ref, () => {
        return {
            afterGuiAttached() {
                // get ref from React component
                const eInput = refInput.current;
                eInput.focus();
                if (highlightAllOnFocus) {
                    eInput.select();
                    setHighlightAllOnFocus(false);
                }
                else {
                    // when we started editing, we want the carot at the end, not the start.
                    // comes into play in two scenarios: a) when user hits F2 and b)
                    // when user hits a printable character, then on IE (and only IE) the carot
                    // was placed after the first character, thus 'apply' would end up as 'pplea'
                    const length = eInput.value ? eInput.value.length : 0;
                    if (length > 0) {
                        eInput.setSelectionRange(length, length);
                    }
                }
            },
            getValue() {
                return value;
            },
            isCancelBeforeStart() {
                return props.charPress && ('1234567890'.indexOf(props.charPress) < 0);
            },
        };
    });
    const updateValue = (value) => {
        const v = Number(value);
        if (props.min && !(v >= props.min)) {
            return;
        }
        if (props.max && !(v <= props.max)) {
            return;
        }
        if (props.step) {
        }
        setValue(v);
    };
    return (react_1.default.createElement("div", { className: "ag-cell-editor" },
        react_1.default.createElement("div", { className: "ag-input-wrapper ag-text-field-input-wrapper ag-wrapper", role: "presentation" },
            react_1.default.createElement("input", { ref: refInput, value: value, type: "text", onChange: event => updateValue(event.target.value), className: "ag-input-field-input" }))));
});
exports.default = NumericEditorReact;
